var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "product-reviews-bazaarvoice" }, [
      _c("div", { staticClass: "tabs" }, [
        _c(
          "a",
          {
            class: { active: _vm.tab === "reviews" },
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.tab = "reviews"
              }
            }
          },
          [_vm._v("Reviews")]
        ),
        _c(
          "a",
          {
            class: { active: _vm.tab === "questions" },
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.tab = "questions"
              }
            }
          },
          [_vm._v("Questions & Answers")]
        )
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            staticClass: "content-page",
            class: { active: _vm.tab == "reviews" }
          },
          [
            _c("div", {
              attrs: {
                "data-bv-show": "reviews",
                "data-bv-product-id": _vm.product
              }
            })
          ]
        ),
        _c(
          "div",
          {
            staticClass: "content-page",
            class: { active: _vm.tab == "questions" }
          },
          [
            _c("div", {
              attrs: {
                "data-bv-show": "questions",
                "data-bv-product-id": _vm.product
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }